export abstract class Builder<T> {
  abstract build(): T;
}
